import { isEmpty } from "lodash";
import { isBeforeDateWithLocal } from "./date";
import { FOOD_COURT } from "../constant/constants";

export const getMatchStatusAction = ({
  matchInfo,
  ticketTypes,
  t,
  user,
  oldOrder,
  isHasTicketType,
}) => {
  let isLimitForUser = true;
  let isSoldOut = true;

  if (!isHasTicketType) {
    return {
      title: t("sold_out"),
      isDisable: true,
    };
  }
  if (oldOrder?.isExist) {
    return {
      title: t("book_now"),
      isDisable: false,
    };
  }
  if (matchInfo?.status === "ENDED" && matchInfo?.category === "SPORT") {
    return {
      title: t("match_result"),
      isDisable: false,
      url: `/match-result/${matchInfo?.slug}`,
    };
  }
  if (matchInfo?.status === "ENDED" && matchInfo?.category === "CONCERT") {
    return {
      title: t("sold_out"),
      isDisable: true,
    };
  }

  ticketTypes.map((itemTicket) => {
    if (itemTicket?.remainingQuantity > 0) {
      isSoldOut = false;
    }
    if (
      itemTicket?.limitForUser > 0 &&
      itemTicket?.numberCanBuy > 0 &&
      itemTicket?.remainingQuantity > 0
    ) {
      isLimitForUser = false;
    }
  });

  if (!isBeforeDateWithLocal(matchInfo?.openForTicket)) {
    return {
      title: t("not_yet_started"),
      isDisable: true,
    };
  }

  if (isEmpty(user)) {
    return {
      title: t("book_now"),
      isDisable: false,
    };
  }

  if (isSoldOut) {
    return {
      title: t("sold_out"),
      isDisable: true,
    };
  }

  if (isLimitForUser) {
    return {
      title:
        matchInfo?.category === FOOD_COURT
          ? t("already_bought_food_court")
          : t("bought_all"),
      isDisable: true,
    };
  }

  return {
    title: t("book_now"),
    isDisable: false,
  };
};
